<template>
  <div class="container mt-5">
    <strong>Rutas</strong>
    <div class="row mb-2">
      <select class="form-control col-6" v-model="ruta">
        <option v-for="ruta in rutas" :value="ruta.Id" :key="ruta.id">{{ ruta.Nombre }}</option>
      </select>
      <div class="col-2">
        <button class="btn btn-dark" @click="generarCodigos()">Generar Gódigos</button>
      </div>
      <div class="col-2">
        <!-- <span class="barcode display-1">*1236*</span> -->
      </div>
    </div>
    <div class="row">
      <table class="table table-bordered">
        <tr v-for="item in items" :key="item.id">
          <td class="text-center" v-for="td in item" :key="td.id">
            <h1 class="barcode display-3">*{{td}}*</h1>
            <h3 style="color:#000; text-shadow:none;">{{td}}</h3>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.obtenerRutas();
  },
  data() {
    return {
      rutas: [],
      items: [],
      ruta: 1,
      url: "https://disosa.herokuapp.com/"
    };
  },
  methods: {
    async obtenerRutas() {
      try {
        let req = await fetch("https://disosa.herokuapp.com/rutas");
        this.rutas = await req.json();
      } catch (error) {
        console.error(error);
      }
    },

    generarCodigos() {
      let n = 1;
      for (let i = 1; i <= 150; i += 2) {
        let item = []
        for (let c = 1; c <= 2; c++) {
          item.push((this.ruta * 1000 + n))
          n++;
        }
        this.items.push(item);
      }
    }
  }
};
</script>

<style lang="css" scoped>
  body { background: #fff;}
</style>